// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class Content extends React.Component {
	render() {
		const { page } = this.props

		const content = (
			<div className="page-section">
				<div className='content-body-text' dangerouslySetInnerHTML={ { __html: page.content.rendered } }></div>

				{ page.notes && page.notes.rendered &&
					<div className='content-notes' dangerouslySetInnerHTML={ { __html: page.notes.rendered } }></div>
				}
			</div>
		)

		return (
			<div className="content-body-wrap">
				<div className="content-body">
					{ content }
				</div>

				<div className="content-side">

				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Content )



// WEBPACK FOOTER //
// ./views/page/Content.jsx